import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";

const Wedding2nd = () => {
  return (
    <div className="wedding2">
      <div className="wedding-2-text-container">
        <h1 className="wedding2-heading">
          Making Your Wedding Dreams Come True
        </h1>
        <div className="wedding2-text">
          Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit sed
          semper vitae faucibus consequat. Sed dui auctor aliquam quam urna
          magna feugiat egestas placerat. Pharetra arcu nulla lacus molestie
          quis dignissim quis tempor interdum. Quam blandit iaculis ante
          pellentesque lectus viverra tristique ultrices. Adipiscing purus
          mattis leo sit mi id sed. Eleifend sed enim odio sapien tincidunt
          viverra. Interdum congue eu bibendum tellus odio. Ridiculus posuere ut
          id imperdiet lorem. Pellentesque turpis mi cras vel risus blandit
          elementum sed neque. Cursus mattis vulputate viverra viverra bibendum
          pharetra cursus. Lobortis pulvinar sed lacus vel lobortis.{" "}
        </div>
        <button className="wedding2-button">Plan Your Dream Wedding</button>
      </div>
      <div className="wedding2-img-container">
        <div className="weddign2-singleimg-container">
          <img
            className="wedding2img"
            src="./Assets/couple1.webp"
            alt="img"
          ></img>
        </div>
        <div className="weddign2-singleimg-container">
          <img
            src="./Assets/couple2.webp"
            alt="img"
            className="wedding2img"
          ></img>
        </div>
        <div className="weddign2-singleimg-container">
          <img
            src="./Assets/couple3.webp"
            className="wedding2img"
            alt="img"
          ></img>
        </div>
      </div>
      <div className="wedding2-swiper">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 1000, disableOnInteraction: false }}
          loop
          slidesPerView={1}
        >
          <SwiperSlide>
            <div className="weddign2-singleimg-container">
              <img
                className="wedding2img"
                src="./Assets/couple1.webp"
                alt="img"
              ></img>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="weddign2-singleimg-container">
              <img
                src="./Assets/couple2.webp"
                alt="img"
                className="wedding2img"
              ></img>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="weddign2-singleimg-container">
              <img
                src="./Assets/couple3.webp"
                className="wedding2img"
                alt="img"
              ></img>
            </div>{" "}
          </SwiperSlide>
        </Swiper>
      </div>

      <div>
        <img
          className="blur_circle1"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>

      <div>
        <img
          className="blur_circle2"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>
    </div>
  );
};

export default Wedding2nd;
